import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export interface FrequenciesAlcoholInterface {
  frequencyName: string
  type?: string
  status: string
}

export default class FrequenciesAlcoholApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get(`frequencies-alcohols`, { params: { ...props } }).then((res) => res)
  }

  static create(frequencyName: string) {
    return this.api.post(`frequencies-alcohols`, { frequencyName, type: 'ALCOHOL' })
  }

  static findById(id: number): Promise<FrequenciesAlcoholInterface> {
    return this.api.get(`frequencies-alcohols/${id}`)
  }

  static update(id: number, body: FrequenciesAlcoholInterface) {
    body.type = 'ALCOHOL'
    return this.api.patch(`frequencies-alcohols/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`frequencies-alcohols/${id}/status`, { id, status })
  }

  static remove(id: number) {
    return this.api.delete(`frequencies-alcohols/${id}`)
  }
}
